import { useCallback, useMemo } from 'react';

import { Drawers } from '@components';
import { useBaseStore } from '@store';

export interface DrawerHook {
	hide: () => void;
	show: () => void;
	isVisible: boolean;
}

export const useDrawer = (modalName: Drawers): DrawerHook => {
	const hideDrawer = useBaseStore((state) => state.hideDrawer);
	const showDrawer = useBaseStore((state) => state.showDrawer);
	const visibleDrawer = useBaseStore((state) => state.visibleDrawer);

	const show = useCallback(() => {
		showDrawer(modalName);
	}, [modalName, showDrawer]);

	const hide = useCallback(() => {
		hideDrawer(modalName);
	}, [modalName, hideDrawer]);

	const isVisible = useMemo(() => {
		return visibleDrawer === modalName;
	}, [modalName, visibleDrawer]);

	return {
		hide,
		show,
		isVisible,
	};
};
